import BusinessConfigProvider from "context/businessConfigContext";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setTheSession } from "redux/slices/authSlice";

const SessionWrapper = ({ children }) => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(setTheSession(auth));
  }, []);

  return (
    <BusinessConfigProvider tenantEnvironment={auth.tenantEnvironment}>
      {children}
    </BusinessConfigProvider>)
};

export default SessionWrapper;
